import 'bootstrap';
import 'bootstrap-datepicker/js/bootstrap-datepicker';
import 'bootstrap-datepicker/js/locales/bootstrap-datepicker.nl';
import 'datatables.net-dt'
import 'datatables.net-bs4'
import '../../application/bundles/datatables/js/datatables';
import 'inputmask/dist/jquery.inputmask.min'
import '../../application/js/application'



// WEBPACK FOOTER //
// resources/assets/scripts/autoload/_bootstrap.js